import thunk from 'redux-thunk';
import reportError from 'ha/helpers/bugsnag/reportError';

import inboxRealtimeMiddleware from 'ha/pages/Inbox/middlewares/realtime';
import listingAuthModalMiddleware from 'ha/pages/Listing/middlewares/authModalMiddleware';
import talkRealtimeMiddleware from 'ha/pages/Talk/middlewares/realtime';

import { createCookiesMiddleware } from 'ha/modules/Cookies';
import {
  delayWeWantToPayModal,
  openWeWantToPayModal,
} from 'ha/modules/WeWantToPay/middleware';
import { urlLocationMiddleware } from 'ha/modules/URLLocationHandler';
import activationModalMiddleware from 'ha/modules/ActivationModal/middlewares/activationModalMiddleware';
import alerts from 'ha/modules/Alertbar/middleware';
import createAnalyticsMiddleware from 'ha/modules/Analytics/middleware';
import fixIosCaretIssueMiddleware from 'ha/modules/UI/middlewares/fixIosCaretIssue';
import hotjarMiddleware from 'ha/modules/Hotjar';
import realtimeMessagingMiddleWare from 'ha/modules/RealtimeMessaging/middleware';
import favoriteListingMiddleware from 'ha/modules/FavoriteListing/middleware';
import inboxCounterMiddleware from 'ha/modules/InboxCounter/middleware';

import crashReporter from './middlewares/crashReporter';
import queryParamsMiddleware from './middlewares/queryParams';
import scroll from './middlewares/scroll';

import { getChannelId } from './getChannelId';
import sanitizeState from './sanitizeState';

export default ({ cookies, debug, errorTracker, history, services }) => {
  const commonMiddlewares = [
    createCookiesMiddleware(cookies),
    thunk.withExtraArgument(services),
  ];

  if (__SERVER__) {
    return commonMiddlewares;
  }

  return [
    ...commonMiddlewares,
    createAnalyticsMiddleware(debug),
    hotjarMiddleware,
    urlLocationMiddleware(),
    queryParamsMiddleware(history),
    listingAuthModalMiddleware(history),
    activationModalMiddleware,
    delayWeWantToPayModal,
    openWeWantToPayModal,
    crashReporter(errorTracker, sanitizeState),
    alerts,
    scroll,
    fixIosCaretIssueMiddleware(global.document.body),
    realtimeMessagingMiddleWare({
      debug,
      onError: reportError,
      getChannelId,
    }),
    inboxRealtimeMiddleware,
    talkRealtimeMiddleware,
    favoriteListingMiddleware,
    inboxCounterMiddleware,
  ];
};
